import styled from 'styled-components';
import {
  transparentize,
} from 'polished';

import {
  Flex,
} from 'web-styled';

import Button from 'web-components/Button';

export const Assign = styled(Flex)`
  width: 100%;
`;

export const Header = styled(Flex).attrs({
  row: true,
})`
  width: 100%;
`;

export const Title = styled.h3`
  color: #9ea0a1;
  font-size: 18px;
  margin: 0;
`;

export const TabLink = styled(Button)`
  color: ${props => (props.active ? props.theme.colors.primary : '#9ea0a1')};
  font-size: 14px;
  font-weight: 400;
  text-decoration: none !important;
  padding: 18px 10px;
  border: 0;
  border-radius: 0;
  border-bottom: 2px solid ${props => (props.active ? props.theme.colors.primary : 'transparent')};
  background-color: transparent;

  &:hover {
    color: ${props => props.theme.colors.primary};
    background-color: transparent;
  }
`;

export const Item = styled(Flex).attrs({
  flex: '0 0 65px',
  align: 'center',
  justify: 'space-between',
})`
  width: 100%;
  padding: 15px;
  border-bottom: 1px solid #ededed;
  cursor: pointer;

  &:first-of-type {
    border-top: 1px solid #ededed;
  }

  &:hover {
    background: ${props => transparentize(0.90, props.theme.colors.primary)};
  }
`;

export const Name = styled.span`
  color: ${props => props.theme.colors.link};
  font-size: 14px;
  line-height: 14px;
`;
